<template>
	<div class="scrollbar" :style="{'--color':color,'--width':width}">
		<slot></slot>

		<a href="#" target="_self" id="toTop" @click="scrolltop()" title="返回顶部" v-if="top">
			<i class="el-icon-caret-top"></i>
			<div style="width: 100%;
			background-color: rgb(242, 245, 246);
			text-align: center;
			line-height: 20px;
			color: rgb(25, 137, 250);">
				UP
			</div>
		</a>
	</div>
</template>

<script>
	export default {
		props: {
			color: {
				type: String,
				default () {
					return '#f3981e'
				}
			},
			width: {
				type: String,
				default () {
					return '4px'
				}
			},
			top: {
				type: Boolean,
				default () {
					return false
				}
			}
		},
		methods: {
			scrolltop() {
				//方法一
				$(".scrollbar").animate({
					scrollTop: 0
				}, 100);
			},
			top_ShowOrHide() {
				$(".scrollbar").scrollTop() > 400 ? $("#toTop").css('opacity', '1') : $("#toTop").css('opacity', '0')
			}
		},
		mounted() {
			$(".scrollbar").scroll(() => {
				this.top_ShowOrHide()
			})
		},
		created() {
			this.scrolltop()
			this.top_ShowOrHide()
		}
	}
</script>

<style >
	.scrollbar {
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	/* 谷歌 */
	.scrollbar::-webkit-scrollbar-track {
		background: rgba(97, 109, 142, .2);
		border-radius: 2px;
	}

	.scrollbar::-webkit-scrollbar-thumb {
		/* background: #f3981e; */
		background: var(--color);
		border-radius: 4px;
	}

	.scrollbar::-webkit-scrollbar {
		width: var(--width);
		height: var(--width);
	}
	
	/* 火狐 */
	/* .scrollbar::-moz-scrollbar-track {
		background: rgba(97, 109, 142, .2);
		border-radius: 2px;
	}
	.scrollbar::-moz-scrollbar-thumb {
		background: var(--color);
		border-radius: 4px;
	}
	.scrollbar::-moz-scrollbar {
		width: var(--width);
		height: var(--width);
	} */
	
	
	

	#toTop {
		transition: all 0.5s;
		opacity: 0;
		background-color: #f2f5f6;
		box-shadow: 0 0 6px rgba(0, 0, 0, .12);
		text-align: center;
		border-radius: 8px;
		color: #1989fa;
		font-size: 20px;
		position: fixed;
		width: 60px;
		height: 55px;
		bottom: 50px;
		right: 30px;
		text-decoration: none;
		box-shadow: 0 0 6px rgba(0, 0, 0, .3);
		z-index: 10;
	}
</style>
